export default "__VITE_ASSET__DVlzXJEJ__"